import { useEffect } from 'react';

const siteUrl = process.env.REACT_APP_SITE_URL;

export const PageMetadata = ({ title, description, path }) => {
  useEffect(() => {
    if (!siteUrl) throw new Error('Missing public site URL configuration');
    const previousTitle = document.title;
    const previousLang = document.documentElement.lang;
    document.title = title;
    document.documentElement.lang = 'es';
    const changes = [];
    const setTag = (selector, tagName, attributes, key, value) => {
      let tag = document.querySelector(selector);
      const created = !tag;
      if (!tag) {
        tag = document.createElement(tagName);
        Object.entries(attributes).forEach(([name, val]) => tag.setAttribute(name, val));
        document.head.appendChild(tag);
      }
      const previous = tag.getAttribute(key);
      tag.setAttribute(key, value);
      changes.push(() => {
        if (created) tag.remove();
        else if (previous === null) tag.removeAttribute(key);
        else tag.setAttribute(key, previous);
      });
    };
    setTag('meta[name="description"]', 'meta', { name: 'description' }, 'content', description);
    setTag('link[rel="canonical"]', 'link', { rel: 'canonical' }, 'href', `${siteUrl}${path}`);
    setTag('meta[property="og:title"]', 'meta', { property: 'og:title' }, 'content', title);
    setTag('meta[property="og:description"]', 'meta', { property: 'og:description' }, 'content', description);
    setTag('meta[property="og:url"]', 'meta', { property: 'og:url' }, 'content', `${siteUrl}${path}`);
    return () => {
      document.title = previousTitle;
      document.documentElement.lang = previousLang;
      changes.forEach(restore => restore());
    };
  }, [title, description, path]);
  return null;
};